import {defineAsyncComponent} from 'vue';

export const HitPanel = defineAsyncComponent(() => import('./HitPanel'));
